import { Button, Flex, Form, List, Popover, Select,Switch } from 'antd';
import { useForm, Controller } from 'react-hook-form';
import PropTypes from 'prop-types';
import { forwardRef, useImperativeHandle } from 'react';
const MODULES_HINT = [
  'Case: Full access to add, submit, and delete cases',
  'Account: Access to accounting features',
  'Report: Access to both case and accounting modules',
];
const UserForm = forwardRef(function UserForm(
  { formValues, onSubmit, loading, isEdit = false },
  ref
) {
  const {
    register,
    formState: { errors },
    control,
    handleSubmit,
    reset,
  } = useForm({
    values: formValues,
    defaultValues: {
      modules: ['CASE'],
    },
  });

  useImperativeHandle(
    ref,
    () => ({
      reset: reset,
    }),
    [reset]
  );

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="form-group">
        <label
          style={{
            zIndex: 10000,
          }}
        >
          Title <span className="login-danger">*</span>
        </label>
        <Controller
          name="nameTitle"
          control={control}
          disabled={isEdit}
          rules={{ required: true }}
          render={({ field }) => (
            <Select
              {...field}
              className="form-control menu-classM"
              options={[
                {
                  value: 'Mr',
                  label: 'Mr',
                },
                {
                  value: 'Mrs',
                  label: 'Mrs',
                },
                {
                  value: 'Ms',
                  label: 'Ms',
                },
                {
                  value: 'Dr',
                  label: 'Dr',
                },
              ]}
            />
          )}
        />

        <small style={{ color: 'red' }}>
          {errors.nameTitle && <p>Please enter Title</p>}
        </small>
      </div>
      <div className="form-group">
        <label>
          First Name <span className="login-danger">*</span>
        </label>
        <input
          className="form-control"
          type="text"
          disabled={isEdit}
          {...register('firstName', { required: true })}
        />
        <small style={{ color: 'red' }}>
          {errors.firstName && <p>Please enter First name</p>}
        </small>
      </div>
      <div className="form-group">
        <label>
          Last Name <span className="login-danger">*</span>
        </label>
        <input
          className="form-control"
          type="text"
          disabled={isEdit}
          {...register('lastName', { required: true })}
        />
        <small style={{ color: 'red' }}>
          {errors.lastName && <p>Please enter Last name</p>}
        </small>
      </div>
      <div className="form-group">
        <label>
          Email <span className="login-danger">*</span>
        </label>
        <input
          className="form-control"
          type="text"
          disabled={isEdit}
          {...register('email', {
            required: 'Please enter Your Email!',
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: 'Please enter A Valid Email!',
            },
          })}
        />
        <small style={{ color: 'red' }}>{errors.email?.message}</small>
      </div>
      <div className="form-group">
        <label
          style={{
            zIndex: 10000,
          }}
        >
          <Flex align="center" gap={3}>
            <div>
              Module <span className="login-danger">*</span>
            </div>
            <Popover
              placement="topLeft"
              content={
                <List
                  dataSource={MODULES_HINT}
                  renderItem={(item) => <List.Item>{item}</List.Item>}
                ></List>
              }
              title="Grant staff member access to the following modules (you can also select all):"
            >
              <i
                onClick={(e) => {
                  e?.preventDefault();
                }}
                className="far fa-circle-question"
                style={{ fontSize: 12 }}
              ></i>
            </Popover>
          </Flex>
        </label>
        <Controller
          name="modules"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <Select
              {...field}
              className="form-control menu-classM"
              mode="multiple"
              disabled={isEdit && formValues?.isAdmin}
              options={[
                { value: 'CASE', label: 'CASE' },
                { value: 'ACCOUNT', label: 'ACCOUNT' },
                { value: 'REPORT', label: 'REPORT' },
              ]}
            />
          )}
        />
        <small style={{ color: 'red' }}>
          {errors.title && <p>Please enter Module</p>}
        </small>
      </div>
      {isEdit && (
        <div className="form-group d-flex align-items-center gap-2">
          <label htmlFor="status-switch" className="form-check-label w-20">
            Status <span className="login-danger">*</span> :
          </label>

          <Controller
            name="status"
            control={control}
            render={({ field }) => (
              <Switch
                id="status-switch"
                checked={field.value}
                onChange={field.onChange}
                checkedChildren="Active"
                unCheckedChildren="Inactive"
              />
            )}
          />
        </div>
      )}
      <Form.Item>
        <Button
          key="ok"
          type="primary"
          htmlType="submit"
          block
          loading={loading}
        >
          Submit
        </Button>
      </Form.Item>
    </form>
  );
});
UserForm.propTypes = {
  formValues: PropTypes.object,
  onSubmit: PropTypes.func,
  loading: PropTypes.bool,
  isEdit: PropTypes.bool,
};
export default UserForm;
